import { UtilitiesService } from 'src/app/shared/services/utilities/utilities.service';
import { CommonSharedServiceService } from 'src/app/shared/shared-services/common-shared-service/common-shared-service.service';
import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DxButtonTypes } from 'devextreme-angular/ui/button';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { LocalStorageService } from 'src/app/shared/services/local-storage/local-storage.service';
import { ShohayBlogService } from 'src/app/shared/services/shohay-blog/shohay-blog.service';
import { I18nServiceService } from 'src/app/shared/shared-services/i18n-service/i18n-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-marketing-header',
  templateUrl: './marketing-header.component.html',
  styleUrls: ['./marketing-header.component.css'],
})
export class MarketingHeaderComponent implements OnInit {
  private viewportWidth: number;
  public sessionUser: any;

  public searchValue: string = '';
  public isModalOpen: boolean = false;
  public showSearchModal: boolean = false;
  public searchResults: any[] = [];

  public isLoggedIn: boolean = false;
  public showHamburger: boolean = false;
  public isMobileView: boolean = false;
  public showLangBtn: boolean = true;
  public verticalNavbar: boolean = false;
  public currentRole: any;

  public profileSettings: any[] = [
    { value: 1, name: 'Change Password', icon: 'edit' },
    { value: 2, name: 'Log Out', icon: 'runner' },
  ];
  public currentUrl: string = '';
  private authSubscription!: Subscription;

  public environment = environment;

  constructor(
    public readonly router: Router,
    private readonly authService: AuthService,
    private readonly translate: TranslateService,
    private readonly i18nService: I18nServiceService,
    private readonly utilitiesService: UtilitiesService,
    private readonly shohayBlogService: ShohayBlogService,
    private readonly localStorageService: LocalStorageService,
    private readonly commonSharedService: CommonSharedServiceService
  ) {
    this.viewportWidth = window.innerWidth;
    this.showHamburger = this.viewportWidth < 1200 ? true : false;
    this.translate.setDefaultLang('en');
    this.translate.use('en');
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.viewportWidth = window.innerWidth;
    this.showHamburger = this.viewportWidth < 1081 ? true : false;
    this.showLangBtn = this.viewportWidth < 745 ? false : true;
    this.isMobileView = this.viewportWidth < 655 ? true : false;
    if (!this.showHamburger) {
      this.verticalNavbar = false;
    }
  }

  public ngOnInit(): void {
    this.sessionUser = this.localStorageService.getSessionUser();
    this.currentRole = this.localStorageService.getSelectedRole();
    this.isLoggedIn = this.authService.isLoggedIn();

    if (window.innerWidth < 455) {
      this.isMobileView = true;
    }
    this.i18nService.localeEvent.subscribe((lang) => this.translate.use(lang));
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url; // Update the URL when navigation ends
      }
    });
    this.currentUrl = this.router.url;
    this.authSubscription = this.authService.authState$.subscribe();
  }

  profileDropDownButtonClick(e: any): void {
    if (e.itemData.value === 1) {
      this.router.navigateByUrl('/auth/change-password');
    } else {
      this.authService.logout();
      this.isLoggedIn = false;
      this.sessionUser = null;
    }
  }

  searchModal(value: boolean): void {
    this.searchValue = '';
    this.showSearchModal = value;
    this.isModalOpen = value;
    this.shohayBlogService.getAllArticleNews().subscribe((result) => {
      this.searchResults = result;
    });
  }

  get filteredResults(): any[] {
    return this.searchResults.filter(
      (item) =>
        item.title.toLowerCase().includes(this.searchValue.toLowerCase()) ||
        item.topic.toLowerCase().includes(this.searchValue.toLowerCase())
    );
  }

  public showVerticalNavbar(): void {
    this.verticalNavbar = !this.verticalNavbar;
  }

  public changeLang(language: string): void {
    this.i18nService.changeLanguage(language);
  }

  public getText(): string {
    if (this.isLoggedIn) {
      return this.translate.instant('Header.Upgrade');
    } else {
      return this.translate.instant('Header.Contact');
    }
  }

  public logOut(): void {
    this.authService.logout();
    this.isLoggedIn = false;
    this.router.navigateByUrl('/');
  }

  public searchIcon: DxButtonTypes.Properties = {
    icon: './assets/images/icon/find_icon.svg',
    stylingMode: 'text',
  };

  public clearMenuIndex(): void {
    this.localStorageService.setSelectedMenuInfo({ menu_key: 'mi_1' });
    this.localStorageService.setSelectedSubMenuInfo(null);
  }

  ngOnDestroy() {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }

  public openNewTab() {
    window.open(
      'https://demo.shohay.net/',
      '',
      'noopener,noreferrer,width=1200,height=800,left=100,top=100'
    );
  }

  onDemoClick(): void {
    if (environment.envName === 'stage') {
      if (!this.isLoggedIn) {
        this.router.navigateByUrl('/');
        this.commonSharedService.updateDemoPopupState(true);
      } else {
        this.utilitiesService.showSwalWithToast(
          'Information',
          'You are already in demo environment.',
          'info',
          false,
          8000
        );
      }
    } else if (
      environment.envName === 'development' ||
      environment.envName === 'production'
    ) {
      this.openNewTab();
    }
  }
}
